import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import { getConfig } from "../config";

interface ApiDetailProps {
  userGroups: string[];
}

export function ApiDetail({ userGroups }: ApiDetailProps) {
  const { apiName } = useParams<{ apiName: string }>();
  const [spec, setSpec] = useState<object | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!apiName) return;

    // Check visibility before loading the spec
    fetch("/api-specs/manifest.json")
      .then((res) => (res.ok ? res.json() : []))
      .then((manifest: { name: string; visibility?: { groups?: string[] } }[]) => {
        const entry = manifest.find((e) => e.name === apiName);
        if (entry?.visibility?.groups?.length) {
          const allowed = entry.visibility.groups.some((g) => userGroups.includes(g));
          if (!allowed) throw new Error("Access denied");
        }
        return fetch(`/api-specs/${apiName}.json`);
      })
      .then((res) => {
        if (!res.ok) throw new Error("Spec not found");
        return res.json();
      })
      .then((data) => {
        setSpec(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [apiName, userGroups]);

  if (loading) return <div className="loading">Loading API documentation...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="api-detail">
      <div className="breadcrumb">
        <Link to="/apis">← Back to Catalog</Link>
      </div>

      <div className="swagger-container">
        {spec && (
          <SwaggerUI
            spec={{
              ...(spec as Record<string, unknown>),
              servers: [
                {
                  url: `${getConfig().apiGatewayUrl}${(spec as any).basePath ?? ""}`,
                  description: "API Gateway",
                },
              ],
            }}
          />
        )}
      </div>

      <style>{`
        .api-detail { max-width: 100%; }
        .breadcrumb { margin-bottom: 1.5rem; }
        .swagger-container { background: var(--color-surface); border: 1px solid var(--color-border); border-radius: 8px; padding: 1rem; }
        .loading, .error { text-align: center; padding: 3rem; }
        .error { color: #dc3545; }
      `}</style>
    </div>
  );
}
